import cn from 'classnames'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../../utils/theme'

const H1 = ({ children, marginBottom, marginTop, withBorder, ...rest }) => (
  <ThemeProvider theme={theme}>
    <Heading
      className={cn({
        marginBottom,
        marginTop,
        withBorder,
      })}
      {...rest}
    >
      {children}
    </Heading>
  </ThemeProvider>
)

const Heading = styled.h1`
  font-size: ${props => props.theme.typography.fontSizeLg};
  font-weight: ${props => props.theme.typography.fontWeightBold};
  color: ${props => props.theme.palette.primary.main};
  margin: 0px;
  &.marginBottom {
    margin-bottom: 16px;
  }
  &.marginTop {
    margin-top: 16px;
  }
  &.withBorder {
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${props => props.theme.body.headingBorderColor};
  }
`

H1.defaultProps = {
  marginBottom: true,
  marginTop: true,
  withBorder: false,
}

export default H1
